import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../../../environments/environment';
import { DashboardScore } from '../../../models/dashboardScore.model';
import { GenericService } from '../../../services/generic.services';
import { LocalStorageService } from '../../../services/localstorage.service';
import { ScoresSportsService } from '../../../services/scores-sports.service';
import { SoundsNotifyService } from '../../../services/sounds-notify.service';
import { SportsService } from '../../../services/sport.service';
import { TranslationService } from '../../../services/translation.service';
import { UtilitiesService } from '../../../services/utilities.service';
import { ExpansionPanelComponent } from '../expansion-panel/expansion-panel.component';
import { ShareModalComponent } from '../share-modal/share-modal.component';
import { ELanguage, getSportRouteByLanguage } from '@/app/utils';
import {
  ROUTE_SPORTS_COMPETITIONS,
  ROUTE_SPORTS_COMPETITIONS_EN,
  ROUTE_SPORTS_MATCHS,
  ROUTE_SPORTS_MATCHS_EN,
  ROUTE_SPORTS_TEAMS,
  ROUTE_SPORTS_TEAMS_EN,
} from '@/app/routes';
import { normalizeRoute } from '@/tools/utils/utils';

@Component({
  selector: 'app-scores-sports-team',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    TranslateModule,
    ShareModalComponent,
    ExpansionPanelComponent,
    NzPopoverModule,
    InfiniteScrollModule,
  ],
  templateUrl: './scores-sports-team.component.html',
  styleUrl: './scores-sports-team.component.scss',
})
export class ScoresSportsTeamComponent {
  dashboard: Array<DashboardScore> = [];
  dashboardOriginal: Array<DashboardScore> = [];
  filterSelected: any = 'All';
  isToday: boolean = false;
  dateSelected: any = '';
  loader: boolean = false;
  today: any = '';

  throttle = 300;
  scrollDistance = 2;
  page = 0;

  urlIcon = environment.urlIcon;
  urlApp = environment.urlApp;

  isOpen: any = null;

  @Input() set dashboardSport(data: {
    date: any;
    filter: any;
    today: boolean;
    dashboard: any;
  }) {
    this.filterSelected = data.filter;
    this.dateSelected = data.date;
    this.isToday = data.today;
    this.dashboardOriginal = data.dashboard;
  }

  @Input() hasFavoriteSport: any = null;

  urlSVG = environment.urlIcon;
  urlIMG = environment.urlIMG;

  private matchInLive: any[] = [];
  private interval: any;

  constructor(
    private readonly translatorService: TranslationService,
    public readonly sportsServices: SportsService,
    private scoresServices: ScoresSportsService,
    private lsService: LocalStorageService,
    private ref: ChangeDetectorRef,
    public utilityService: UtilitiesService,
    private soundEffect: SoundsNotifyService,
    private toastr: ToastrService,
    private readonly genericServices: GenericService
  ) {
    if (!this.dashboardSport || !this.dashboardSport.date)
      this.dateSelected = this.genericServices.getCurrentDate();
  }

  ngOnInit(): void {
    this.today = this.genericServices.getCurrentDate();
    this.loader = true;

    this.matchInLive = [];
    this.loadDashboard();
    setTimeout(() => {
      this.loader = false;
    }, 1000);
    if (this.isToday) this.refreshDashboard();
    else clearInterval(this.interval);
  }

  loadDashboard(): void {
    if (this.page > this.dashboardOriginal.length) return;
    this.dashboardOriginal
      .slice(this.page, this.page + 10)
      .forEach((data: DashboardScore) => {
        let results: any = data.results;
        results.forEach((result: any, index: number) => {
          if (Object.keys(result.score).length > 0) {
            if (result.statusId === 2) {
              result.homeScores.scoreFinal = result.score.homeTeam.current;
              result.awayScores.scoreFinal = result.score.awayTeam.current;
              result.homeTeam.link = this.getLinkSportTeam(
                this.utilityService.getCountry(data.country?.country ?? null),
                result.homeTeam.name,
                result.homeTeam.id
              );
              result.awayTeam.link = this.getLinkSportTeam(
                this.utilityService.getCountry(data.country?.country ?? null),
                result.awayTeam.name,
                result.awayTeam.id
              );

              result.link = this.getLinkSportMatch(
                result.id,
                result.homeTeam.id,
                result.awayTeam.id,
                data.idCompetition
              );
            }
          }
        });

        this.dashboard.push({
          active: data.active,
          banner: data.banner,
          category: data.category,
          competitionName:
            this.translatorService.getCurrentLanguage() == 'es'
              ? data.nameEs
              : data.nameEn,
          nameEs: data.nameEs,
          nameEn: data.nameEn,
          competitionLogo: data.competitionLogo,
          country: data.country,
          favorite: data.favorite,
          order: data.order,
          idCompetition: data.idCompetition,
          idSeason: data.idSeason,
          isBanner: data.isBanner,
          results,
          stageData: data.stageData,
          yearSeason: data.yearSeason,
          sport: this.hasFavoriteSport,
          link: this.getLinkSportCompetition(
            this.utilityService.getCountry(data.country?.country ?? null),
            this.translatorService.getCurrentLanguage() === ELanguage.ES
              ? data.nameEs
              : data.nameEn,
            data.idCompetition
          ),
        });
      });

    this.ref.markForCheck();
    this.page = this.page + 10;
  }
  // TODO: delete favorito
  // favoriteCompetition(competition: any) {
  //   if (
  //     this.lsService.setFavoritesCompetition(competition, this.hasFavoriteSport)
  //   ) {
  //     competition.favorite = !competition.favorite;
  //     this.ref.markForCheck();
  //   }
  // }
  getLinkSportCompetition(
    country: string,
    name: string,
    competitionId: string
  ): string {
    if (this.translatorService.getCurrentLanguage() === ELanguage.EN) {
      const route = `/${ROUTE_SPORTS_COMPETITIONS_EN.replace(
        ':sport',
        getSportRouteByLanguage(
          ELanguage.EN,
          this.sportsServices.getSelectedSport()
        )
      )
        .replace(':country', normalizeRoute(country))
        .replace(':leagueName', normalizeRoute(name))
        .replace(':idCompetition', competitionId)}`;

      return route;
    } else {
      const route = `/${ROUTE_SPORTS_COMPETITIONS.replace(
        ':sport',
        getSportRouteByLanguage(
          ELanguage.ES,
          this.sportsServices.getSelectedSport()
        )
      )
        .replace(':country', normalizeRoute(country))
        .replace(':leagueName', normalizeRoute(name))
        .replace(':idCompetition', competitionId)}`;

      return route;
    }
  }

  getLinkSportMatch(
    matchId: string,
    homeId: string,
    awayId: string,
    competitionId: string
  ): string {
    if (this.translatorService.getCurrentLanguage() === ELanguage.EN) {
      const route = `/${ROUTE_SPORTS_MATCHS_EN.replace(
        ':sport',
        getSportRouteByLanguage(
          ELanguage.EN,
          this.sportsServices.getSelectedSport()
        )
      )
        .replace(':id', matchId)
        .replace(':idHome', homeId)
        .replace(':idAway', awayId)
        .replace(':idCompetition', competitionId)
        .replace(':date', this.dateSelected)}`;

      return route;
    } else {
      const route = `/${ROUTE_SPORTS_MATCHS.replace(
        ':sport',
        getSportRouteByLanguage(
          ELanguage.ES,
          this.sportsServices.getSelectedSport()
        )
      )
        .replace(':id', matchId)
        .replace(':idHome', homeId)
        .replace(':idAway', awayId)
        .replace(':idCompetition', competitionId)
        .replace(':date', this.dateSelected)}`;

      return route;
    }
  }

  getLinkSportTeam(country: string, team: string, teamId: string): string {
    if (this.translatorService.getCurrentLanguage() === ELanguage.EN) {
      const route = `/${ROUTE_SPORTS_TEAMS_EN.replace(
        ':sport',
        getSportRouteByLanguage(
          ELanguage.EN,
          this.sportsServices.getSelectedSport()
        )
      )
        .replace(':country', normalizeRoute(country))
        .replace(':teamName', normalizeRoute(team))
        .replace(':idTeam', teamId)}`;

      return route;
    } else {
      const route = `/${ROUTE_SPORTS_TEAMS.replace(
        ':sport',
        getSportRouteByLanguage(
          ELanguage.ES,
          this.sportsServices.getSelectedSport()
        )
      )
        .replace(':country', normalizeRoute(country))
        .replace(':teamName', normalizeRoute(team))
        .replace(':idTeam', teamId)}`;

      return route;
    }
  }
  favoriteMatch(match: any, idCompetition: any) {
    if (
      this.lsService.setFavoritesMatch(
        match,
        idCompetition,
        match.matchDateISO,
        this.hasFavoriteSport
          ? this.hasFavoriteSport
          : this.sportsServices.getSelectedSport()
      )
    ) {
      match.favorite = !match.favorite;
      this.ref.markForCheck();
    }
  }

  refreshDashboard() {
    if (!this.isToday) {
      clearInterval(this.interval);
      return;
    }
    const self = this;
    this.interval = setInterval(function () {
      self.scoresServices
        .refreshMatchesSchedule(self.dateSelected, self.filterSelected)
        .subscribe(
          (matches: any) => {
            if (matches.status) {
              self.updateMatchesCompetition(matches.data);
            }
          },
          () => {}
        );
    }, 10000);
  }

  updateMatchesCompetition(matchesUpdate: any) {
    this.ref.detectChanges();
    this.dashboard.forEach((competition: any, index: number) => {
      competition.results.forEach(async (match: any, index: number) => {
        const updateMatch: any = matchesUpdate.find(
          (elem: any) => elem.id === match.id
        );
        if (updateMatch) {
          match.statusId = updateMatch.statusId;
          match.status = updateMatch.status;
          match.matchTime = updateMatch.matchTime;
          match.matchDate = updateMatch.matchDate;
          match.homeScores = updateMatch.homeScores;
          match.awayScores = updateMatch.awayScores;
          match.score = updateMatch.score;
          match.incidents = updateMatch.incidents;
          match.link = this.getLinkSportMatch(
            updateMatch.id,
            updateMatch.homeTeam.id,
            updateMatch.awayTeam.id,
            competition.idCompetition
          );
          match.homeTeam = {
            ...updateMatch.homeTeam,
            link: this.getLinkSportTeam(
              this.utilityService.getCountry(
                competition.country?.country ?? null
              ),
              updateMatch.homeTeam.name,
              updateMatch.homeTeam.id
            ),
          };
          match.awayTeam = {
            ...updateMatch.awayTeam,
            link: this.getLinkSportTeam(
              this.utilityService.getCountry(
                competition.country?.country ?? null
              ),
              updateMatch.awayTeam.name,
              updateMatch.awayTeam.id
            ),
          };
          if (Object.keys(updateMatch.score).length > 0) {
            if (match.statusId === 2) {
              match.homeScores.scoreFinal = match.score.homeTeam.current;
              match.awayScores.scoreFinal = match.score.awayTeam.current;
            }
          }
          await this.matchsInLive(match);
        }
      });
    });
    this.ref.markForCheck();
  }

  matchsInLive(match: any) {
    return new Promise((resolve) => {
      if (match.statusId === 2) {
        const findMatch: any = this.matchInLive.find(
          (item: any) => item.id === match.id
        );
        if (findMatch) {
          findMatch.statusId = match.statusId;
          (findMatch.homeScores = match.homeScores),
            (findMatch.awayScores = match.awayScores),
            (findMatch.score = match.score);
          if (match.incidents.length > findMatch.incidents.length) {
            findMatch.incidents = match.incidents;
            const incident = match.incidents[match.incidents.length - 1];
            if (
              incident.type.code === 1 ||
              incident.type.code === 8 ||
              incident.type.code === 16 ||
              incident.type.code === 17 ||
              incident.type.code === 29 ||
              incident.type.code === 30
            ) {
              const textHTML: any = `
                <div class="team-info">
                    <div class="flag-team">
                        <img alt="logo" src="${
                          match.homeTeam.logo != ''
                            ? match.homeTeam.logo
                            : this.urlIMG + 'default.png'
                        }" />
                    </div>
                    <div class="name-team">
                        ${match.homeTeam.name}
                    </div>
                    <div class="text-score">
                        (${match.homeScores.scoreFinal})
                    </div>
                    <div>-</div>
                    <div class="flag-team">
                        <img alt="logo" src="${
                          match.awayTeam.logo != ''
                            ? match.awayTeam.logo
                            : this.urlIMG + 'default.png'
                        }" />
                    </div>
                    <div class="name-team">
                        ${match.awayTeam.name}
                    </div>
                    <div class="text-score">
                        (${match.awayScores.scoreFinal})
                    </div>
                </div>
                <div class="info-gol">
                  <img alt="logo" src="${incident.type.svg}"/>
                  <span class="text-incident">
                      ${
                        incident.playerName || incident.playerNameShort
                          ? incident.playerNameShort != ''
                            ? incident.playerNameShort
                            : incident.playerName
                          : incident.position.code === 1
                          ? match.homeTeam.name
                          : match.awayTeam.name
                      }
                      ${
                        !incident.playerName
                          ? ''
                          : incident.position.code === 1
                          ? ' (' + match.homeTeam.name + ')'
                          : ' (' + match.awayTeam.name + ')'
                      }
                  </span>
                </div>
              `;
              this.showSuccess(textHTML, '');
              this.soundEffect.playGold();
              setTimeout(() => {}, 200);
              resolve(true);
            } else if (
              incident.type.code === 11 ||
              incident.type.code === 12 ||
              incident.type.code === 26 ||
              incident.type.code === 27
            ) {
              const textHTML: any = `
                <div class="team-info">
                  <div class="flag-team">
                      <img alt="logo" src="${
                        match.homeTeam.logo != ''
                          ? match.homeTeam.logo
                          : this.urlIMG + 'default.png'
                      }" />
                  </div>
                  <div class="name-team">
                      ${match.homeTeam.name}
                  </div>
                  <div class="text-score">
                      (${match.homeScores.scoreFinal})
                  </div>
                  <div>-</div>
                  <div class="flag-team">
                      <img alt="logo" src="${
                        match.awayTeam.logo != ''
                          ? match.awayTeam.logo
                          : this.urlIMG + 'default.png'
                      }" />
                  </div>
                  <div class="name-team">
                      ${match.awayTeam.name}
                  </div>
                  <div class="text-score">
                      (${match.awayScores.scoreFinal})
                  </div>
                </div>
                <div class="info-gol">
                  <img alt="logo" src="${incident.type.svg}"/>
                  <span class="text-incident">
                      ${incident.type.text}
                  </span>
                </div>
              `;
              this.showSuccess(textHTML, '');
              incident.type.code === 11
                ? this.soundEffect.playRefereeBegin()
                : this.soundEffect.playRefereeEnd();
              setTimeout(() => {}, 200);
              resolve(true);
            }

            resolve(true);
          } else resolve(true);
        } else {
          this.matchInLive.push({
            ...match,
          });
          resolve(true);
        }
      } else {
        const findMatch: any = this.matchInLive.findIndex(
          (item: any) => item.id === match.id
        );
        if (findMatch > -1) {
          this.matchInLive.splice(findMatch, 1);
        }
        resolve(true);
      }
    });
  }

  showSuccess(text: any, title: any) {
    this.toastr.success(text, title);
  }

  transform(text: string, length: number = 50, suffix: string = '...'): string {
    if (text.length > length)
      return text.substring(0, length).trim().concat(suffix);

    return text;
  }

  openModal(matchId: any) {
    this.isOpen = matchId;
  }

  ngOnDestroy(): void {
    this.matchInLive = [];
    clearInterval(this.interval);
  }
}
